module.exports = __webpack_public_path__ + "static/sprite-qa-86c269da72e154bee111f74567d5f864.png";